import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=960c7a2a&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=960c7a2a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960c7a2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('960c7a2a')) {
      api.createRecord('960c7a2a', component.options)
    } else {
      api.reload('960c7a2a', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=960c7a2a&scoped=true&", function () {
      api.rerender('960c7a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ESqWfhVVOyW6/JS/comp/Paginate.vue"
export default component.exports